(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/selectors/assets/javascripts/funds.js') >= 0) return;  svs.modules.push('/components/marketplace-data/selectors/assets/javascripts/funds.js');
"use strict";


const selectFunds = state => {
  var _state$Funds;
  return (_state$Funds = state.Funds) === null || _state$Funds === void 0 ? void 0 : _state$Funds.data;
};
const selectJackpots = state => {
  var _state$Jackpots;
  return (_state$Jackpots = state.Jackpots) === null || _state$Jackpots === void 0 ? void 0 : _state$Jackpots.data;
};
const selectFundsError = state => {
  var _state$Funds2;
  return (_state$Funds2 = state.Funds) === null || _state$Funds2 === void 0 ? void 0 : _state$Funds2.error;
};
const selectJackpotsError = state => {
  var _state$Jackpots2;
  return (_state$Jackpots2 = state.Jackpots) === null || _state$Jackpots2 === void 0 ? void 0 : _state$Jackpots2.error;
};
const selectFundsIsLoading = state => {
  var _state$Funds3;
  return (_state$Funds3 = state.Funds) === null || _state$Funds3 === void 0 ? void 0 : _state$Funds3.isLoading;
};
const selectJackpotsIsLoading = state => {
  var _state$Jackpots3;
  return (_state$Jackpots3 = state.Jackpots) === null || _state$Jackpots3 === void 0 ? void 0 : _state$Jackpots3.isLoading;
};
const selectFundsLastFetch = state => {
  var _state$Funds4;
  return (_state$Funds4 = state.Funds) === null || _state$Funds4 === void 0 ? void 0 : _state$Funds4.lastFetch;
};
const selectJackpotsLastFetch = state => {
  var _state$Jackpots4;
  return (_state$Jackpots4 = state.Jackpots) === null || _state$Jackpots4 === void 0 ? void 0 : _state$Jackpots4.lastFetch;
};
const selectJackpotByDrawNumberAndProductId = (state, _ref) => {
  let drawNumber = _ref.drawNumber,
    productId = _ref.productId;
  const funds = selectJackpots(state);
  if (funds === undefined) {
    return null;
  }
  return funds.find(fund => fund.drawNumber === drawNumber && fund.productId === productId);
};
const selectFundsByDrawNumberAndProductId = (state, _ref2) => {
  let drawNumber = _ref2.drawNumber,
    productId = _ref2.productId;
  const funds = selectFunds(state);
  if (funds === undefined) {
    return null;
  }
  return funds.find(fund => fund.drawNumber === drawNumber && fund.productId === productId);
};
setGlobal('svs.components.marketplaceData.selectors.funds', {
  selectFundsByDrawNumberAndProductId,
  selectFunds,
  selectJackpots,
  selectFundsError,
  selectJackpotsError,
  selectFundsIsLoading,
  selectJackpotsIsLoading,
  selectFundsLastFetch,
  selectJackpotsLastFetch,
  selectJackpotByDrawNumberAndProductId
});

 })(window);